<template>
  <div class="ws-btn">
    <v-btn
      :href="googleLink"
      class="mt-5 px-5 secondary--text social-g"
      type="submit"
      block
      color="white"
    >
    <!-- src="@/assets/social_g.svg" -->
      <v-img
        
        :height="24"
        :max-width="24"
      />
      <div class="pr-5 flex-grow-1">
        Google {{ $t('登入') }}
      </div>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "WsSocialiteBtnGoogle001",
};
</script>

<style>
</style>